import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';

import Login from './screens/Login';
import UserList from './screens/UserList';
import AddRole from './screens/addRole';
import Roles from './screens/Roles';
import SideBar from './components/SideBar';
import Container from './components/Container';
import UserByID from './screens/UserById';
import Dashboard from './screens/Dashboard';
import RoleByID from './screens/RoleById';
import './assests/styles.css';
import './App.css';
import './assests/scripts';
import EventsList from "./screens/events/EventsList";
import EventEdit from "./screens/events/EventEdit";
import CategoriesList from "./screens/categories/CategoriesList";
import BookingsDashboard from "./components/dashboard/BookingsDashboard";
import CheckerManagement from "./screens/CheckerManagement";
import LiveAttendance from "./screens/LiveAttendance";

function App() {
  return (
    <Router>
      <ToastContainer />
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="*" element={<DefaultContainer />} />
      </Routes>
    </Router>
  );
}

const DefaultContainer = () => {
  return (
    <Container>
      <SideBar />
      <div className='mx-auto py-10 px-6 bg-gray-100 overflow-x-auto w-4/5'>
        <Routes>
          <Route path="/dashboard" element={<Dashboard />} exact />
          <Route path="/bookings" element={<BookingsDashboard />} exact />
          <Route path="/users" element={<UserList />} exact />
          <Route path="/users/:id" element={<UserByID />} exact />
          <Route path="/roles" element={<Roles />} exact />
          <Route path='/roles/add' element={<AddRole />} exact />
          <Route path='/roles/update/:id' element={<RoleByID />} />
          <Route path="/events" element={<EventsList />} />
          <Route path="/events/:id" element={<EventEdit />} />
          <Route path="/categories" element={<CategoriesList />} />
          <Route path="/checkers" element={<CheckerManagement />} />
          <Route path="/live-attendance" element={<LiveAttendance />} />
        </Routes>
      </div>
    </Container>
  );
};

export default App;
